import { Card } from "antd";
import VerifyHeatMap from "../../verifiers/verify_heat_map";

export default function HeatMapWrapper({ selectedDate, isLastRecordPending }) {
  return (
    <Card
      title="Mapa de calor aplicado às câmeras"
      align="center"
      style={{
        width: "85%",
      }}
      styles={{
        header: {
          backgroundColor: "#d0d6e2",
        },
      }}>
      <VerifyHeatMap
        selectedDate={selectedDate}
        isLastRecordPending={isLastRecordPending}
      />
    </Card>
  );
}
